import { DraggableObject } from "./dragReducer";


const setDrag = (
    dragging: boolean,
    draggedObject?: DraggableObject | undefined,
    onDrop?: () => void,
    onCancel?: () => void,
) => ({
    type: 'DRAG/SET_DRAGGING',
    dragging,
    draggedObject,
    onDrop,
    onCancel,
});

const deleteDrag = () => ({
    type: 'DRAG/STOP_DRAGGING',
});

export {
    setDrag,
    deleteDrag,
};
